// context/SnackbarContext.js
import { createContext, useContext, useState } from "react"

const SnackbarContext = createContext()

export function SnackbarProvider({ children }) {
  const [snackbar, setSnackbar] = useState(null)

  const showSnackbar = (message, type = "success") => {
    setSnackbar({ message, type })

    setTimeout(() => {
      setSnackbar(null)
    }, 3000)
  }

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}

      {snackbar && (
        <div
          className={`position-fixed bottom-0 start-50 translate-middle-x mb-4 px-3 py-2 rounded shadow text-white ${
            snackbar.type === "success" ? "bg-success" : "bg-danger"
          }`}
          style={{ zIndex: 9999 }}
        >
          {snackbar.message}
        </div>
      )}
    </SnackbarContext.Provider>
  )
}

export const useSnackbar = () => useContext(SnackbarContext)
